import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGem, faPlus, faSpinner } from '@fortawesome/free-solid-svg-icons';
import './ServiceWallet.css';

interface WalletChipProps {
  balance: number | null;
  onAdd: () => void;
  label?: string;
  addLabel?: string;
  loading?: boolean;
  formatBalance?: (balance: number) => string;
}

const WalletChip: React.FC<WalletChipProps> = ({
  balance,
  onAdd,
  label = 'Credits',
  addLabel = 'Add credits',
  loading = false,
  formatBalance,
}) => {
  const value = balance === null ? '\u2014' : formatBalance ? formatBalance(balance) : String(balance);
  const isEmpty = balance !== null && balance < 1;
  const description = `${label}: ${value}. ${addLabel}`;

  return (
    <button
      type="button"
      className={`sw-chip${isEmpty ? ' sw-chip--empty' : ''}`}
      onClick={onAdd}
      title={description}
      aria-label={description}
    >
      <span className="sw-chip-icon" aria-hidden="true">
        <FontAwesomeIcon icon={faGem} />
      </span>
      <span className="sw-chip-copy">
        {loading ? (
          <FontAwesomeIcon icon={faSpinner} spin className="sw-chip-spinner" />
        ) : (
          <span className="sw-chip-value">{value}</span>
        )}
      </span>
      <span className="sw-chip-plus" aria-hidden="true">
        <FontAwesomeIcon icon={faPlus} />
      </span>
    </button>
  );
};

export default WalletChip;
